import { OFFICIAL_SOURCES } from '../officialSources';

/** Guided step blocks reused across trekking journeys */
export const SHARED_GUIDED_STEPS = {
	visa: {
		objective: 'Secure a valid Nepal tourist visa before or on arrival',
		why: 'No visa = no entry. Most treks need a 30-day tourist visa minimum',
		estimatedTime: '20 min online · 30–60 min at airport',
		prerequisites: ['research'],
		documentsRequired: ['Passport (MRP)', 'Passport photo', 'USD cash or card for fee'],
		taskChecklist: [
			{ id: 'visa-applied', label: 'Online visa form submitted (or VOA plan confirmed)' },
			{ id: 'visa-fee-ready', label: 'USD 50 ready for 30-day visa' },
			{ id: 'visa-stamped', label: 'Visa stamp received in passport' },
		],
		actions: [
			{
				id: 'apply-online',
				title: 'Apply online (recommended before you fly)',
				type: 'online',
				description: 'Complete the form before your flight — saves time at TIA immigration.',
				officialUrl: OFFICIAL_SOURCES.immigrationOnline.url,
				officialLabel: 'Nepal Online Visa Application',
				bring: ['Passport details', 'Digital passport photo', 'Hotel address in Kathmandu'],
				mistakes: ['Waiting until landing to start the form', 'Using a non-machine-readable passport'],
			},
		],
		officialPdfs: [
			{ label: 'Tourist visa information', url: OFFICIAL_SOURCES.immigration.url },
			{ label: 'TIA arrival FAQ', url: OFFICIAL_SOURCES.immigrationTia.url },
		],
	},
	guide: {
		objective: 'Decide guide vs independent — and verify current rules',
		why: 'Policy changes — some routes now require licensed guides. Even when optional, guides help with altitude and logistics',
		estimatedTime: '20 minutes',
		prerequisites: ['permits'],
		taskChecklist: [
			{ id: 'policy-checked', label: 'Checked current NTB guide requirement for my route' },
			{ id: 'guide-decision', label: 'Decided: independent, guide only, or full package' },
		],
	},
	sherpa: {
		objective: 'If hiring, book through a licensed agency',
		why: 'Unlicensed guides at airports are a common scam — use TAAN-registered agencies',
		estimatedTime: '30 minutes research',
		prerequisites: ['guide'],
		taskChecklist: [
			{ id: 'agency-shortlist', label: 'Shortlisted TAAN-registered agencies' },
			{ id: 'written-itinerary', label: 'Received written itinerary and inclusions' },
		],
	},
	porter: {
		objective: 'Arrange porter if you want a light daypack on trail',
		why: 'Porters carry your duffel — you walk with 5–8 kg. Standard on longer treks',
		estimatedTime: '15 minutes',
		prerequisites: ['guide'],
		taskChecklist: [
			{ id: 'porter-booked', label: 'Porter arranged (or decided to carry own gear)' },
			{ id: 'weight-limit', label: 'Duffel under porter weight limit (typically 15 kg)' },
		],
	},
	kathmandu: {
		objective: 'Prep in Kathmandu — SIM, cash, gear, permits',
		why: '2–3 days in Kathmandu before the trail — ATMs, gear shops, and permit offices are here',
		estimatedTime: '1–2 days on ground',
		prerequisites: ['packing'],
		taskChecklist: [
			{ id: 'hotel-booked', label: 'First/last nights hotel booked in Thamel' },
			{ id: 'sim-purchased', label: 'Ncell or NTC SIM purchased' },
			{ id: 'cash-withdrawn', label: 'NPR cash withdrawn for trail' },
		],
	},
	emergency: {
		objective: 'Know AMS signs, evacuation procedure, and emergency numbers',
		why: 'Altitude sickness and helicopter rescue — know this before you need it',
		estimatedTime: '20 minutes',
		prerequisites: ['trek'],
		taskChecklist: [
			{ id: 'ams-learned', label: 'AMS symptoms and golden rules understood' },
			{ id: 'insurer-number', label: 'Insurer emergency number saved offline' },
			{ id: 'tourist-police', label: 'Tourist Police 1144 saved' },
		],
	},
	return: {
		objective: 'Close the loop — travel home safely',
		why: 'Buffer days prevent missed international flights after weather delays',
		estimatedTime: '2–3 days',
		taskChecklist: [
			{ id: 'transport-home', label: 'Return transport to Kathmandu completed' },
			{ id: 'intl-departure', label: 'International departure completed' },
		],
	},
};

/** Merge shared steps with trek-specific overrides */
export function mergeStepGuided(trekSpecific) {
	return { ...SHARED_GUIDED_STEPS, ...trekSpecific };
}
